import { useEffect, useState } from "react";
import { loginUserSelector } from "../../recoil/selectors/loginUserSelector";
import { useRecoilValue } from "recoil";
import { useApiGetTaskProgress } from "../api/useApiGetTaskProgress";
import iconMap from "../../constants/iconMap";
import Router from "../../router/routes";

export const useWorkProgressLogic = () => {
  const user = useRecoilValue(loginUserSelector);
  const userId = user?.id;
  const { taskProgressCounts, fetchTaskProgress, isLoading, error } =
    useApiGetTaskProgress();
  const [statusCards, setStatusCards] = useState<
    { id: number; icon: string; count: string; link: string }[]
  >([]);

  const statusIdToRoute: Record<number, string> = {
    1: Router.pendingReceipt,
    2: Router.pendingPackaging,
    3: Router.pendingPlan,
    4: Router.pendingShipment,
    5: Router.shipped,
    6: Router.needsReview,
  };

  useEffect(() => {
    if (userId) {
      fetchTaskProgress({ userId: userId });
    }
  }, [userId]);

  useEffect(() => {
    const mergedCounts: Record<number, number> = {};

    taskProgressCounts?.forEach((item) => {
      const id = item.statusId ?? 0;
      const count = item.itemCount ?? 0;

      if (id === 6 || id === 7) {
        mergedCounts[6] = (mergedCounts[6] || 0) + count;
      } else {
        mergedCounts[id] = (mergedCounts[id] || 0) + count;
      }
    });

    const cards = Object.entries(iconMap).map(([idStr, icon]) => {
      const id = Number(idStr);
      return {
        id,
        icon,
        count: `${mergedCounts[id] ?? 0}件`,
        link: statusIdToRoute[id] || Router.notFound,
      };
    });

    setStatusCards(cards);
  }, [taskProgressCounts]);

  return { statusCards, isLoading, error };
};
